import React from "react";

interface DocumentPreviewProps {
  src: string;
  alt: string;
  file?: File | null;
  imageClassName?: string;
}

const isPdf = (src: string, file?: File | null): boolean => {
  if (file?.type === "application/pdf") return true;
  return src.split("?")[0].toLowerCase().endsWith(".pdf");
};

const DocumentPreview: React.FC<DocumentPreviewProps> = ({
  src,
  alt,
  file,
  imageClassName = "max-h-48 object-contain",
}) => {
  if (isPdf(src, file)) {
    return (
      <iframe
        src={`${src}#toolbar=0`}
        title={alt}
        className="w-full h-48"
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={imageClassName}
    />
  );
};

export default DocumentPreview;
